import { Organization } from '../../models/organization.class';
import { User } from '../../models/user.class';

import { ClientDetails } from '../../interface/client-details.interface';

export const authInitialState: AuthInitialState = {
    client: {
        clientDetails: undefined,
        errorResponse: undefined,
    },
    token: {
        details: undefined,
    },
    applicationProperties: {
        'analytics.service.types': undefined,
        'default.provider.id': undefined,
        'taxilla.version': undefined,
    },
    is4ecEnabled: false,
};

export const resetPasswordInitialState: ResetPasswordInitialState = {
    security: {
        secretQuestions: [],
    },
    captcha: {
        captcha: undefined,
        plain: undefined,
        forgotPswd: undefined,
        forgotUsername: undefined,
    },
    context: {
        organization: undefined,
        user: undefined,
        settings: undefined,
    },
};
// Interfaces
export interface ResetPasswordInitialState {
    security: {
        secretQuestions: string[];
    };
    captcha: {
        captcha: string;
        plain?: boolean;
        forgotPswd?: boolean;
        forgotUsername?: boolean;
    };
    context: {
        organization: Organization;
        settings: any;
        user: User;
    };
}

export interface AuthInitialState {
    client?: {
        clientDetails: ClientDetails;
        errorResponse: { msg?: string; text?: string };
    };
    token?: {
        details?: {
            access_token?: string;
            expires_in?: number;
            orgId?: string;
            refresh_token?: string;
            resourceOwnerId?: string;
            scope?: [];
            token_type?: string;
        };
    };
    applicationProperties: {
        'analytics.service.types': string;
        'default.provider.id': string;
        'taxilla.version': string;
    };
    is4ecEnabled: boolean;
}
